import { Component, h, RefObject } from 'preact';
import linkState from 'linkstate';

import { ReqState } from '../../../../../types';
import { PROPERTY_KEY_PATTERN } from '../../../../../constants';

import { MultiChipInput } from '../../common/multi-chip-input.component';
import { listingService } from '../../../../utils/listing.service';

interface AddClientPropertySelectProps {
  propertyKeys: string[];
  showInvalidState?: boolean;
  
  onChange: (keys: string[]) => void;
}

interface AddClientPropertySelectState {
  textValue?: string;
  propReqState?: ReqState;
}

export class AddClientPropertySelect extends Component<AddClientPropertySelectProps, AddClientPropertySelectState> {
  async onAdd() {
    const textValue = this.state.textValue.toUpperCase();
    const keys = this.props.propertyKeys || [];

    if (keys.includes(textValue)) {
      this.setState({ textValue: ''});
    } else {
      try {
        this.setState({ propReqState: ReqState.IN_PROGRESS });
        await listingService.getByKey(this.state.textValue);
        this.setState({ propReqState: ReqState.SUCCESS, textValue: '' });

        const newKeys = [ ...keys, textValue ];
        this.props.onChange(newKeys);
      } catch (err) {
        this.setState({ propReqState: ReqState.FAILED });
      }
    }
  }

  onEnterKeyPress() {
    if (this.isAddButtonEnabled()) {
      this.onAdd();
    }
  }

  isAddButtonEnabled() {
    const state = this.state;
    const inProgress = state.propReqState === ReqState.IN_PROGRESS;
    const input = state.textValue || '';
    const hasText = !!state.textValue;
    const formatValid = input && input.match(PROPERTY_KEY_PATTERN);

    return (!inProgress && hasText && formatValid);
  }

  render(props: AddClientPropertySelectProps, state: AddClientPropertySelectState) {
    return (
      <div className="hi-input-group hi-addclpropsel">
        <label className="hi-input-group__label">
          Property ID
        </label>
        <div className="d-flex align-items-center">
          <div className="flex-fill hi-mr-20">
            <MultiChipInput onInput={ linkState(this, 'textValue') }
              textValue={ this.state.textValue }
              chipValues={ props.propertyKeys }
              onChipListChange={ chips => props.onChange(chips) }
              maxLength={ 12 }
              showInvalidState={ props.showInvalidState }
              onEnterKeyPress={ () => this.onEnterKeyPress()  } />
          </div>
          <button type="button" className="btn btn-outline-dark hi-form-button"
            disabled={ !this.isAddButtonEnabled() }
            onClick={ () => this.onAdd() }>
            Add
          </button>
        </div>

        { state.propReqState === ReqState.FAILED && (
          <span className="text-danger hi-type-caption-mobile-ink">
            Could not find a property with this ID.
          </span>
        ) }
      </div>
    );
  }
}